module.exports = __webpack_public_path__ + "img/02-2解决方案.13e18127.svg";